/* eslint-disable */
import * as Types from '../../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PdsSyncSettings_AddMutationVariables = Types.Exact<{
  input: Types.AddOrganisationIntegrationInput;
}>;


export type PdsSyncSettings_AddMutation = { addOrganisationIntegration: { __typename: 'AddOrganisationIntegrationResult', organisationIntegration: { __typename: 'OrganisationIntegration', id: string, settings: any, integration: { __typename: 'Integration', integrationId: Types.IntegrationId } } } };

export type PdsSyncSettings_UpdateMutationVariables = Types.Exact<{
  input: Types.UpdateOrganisationIntegrationInput;
}>;


export type PdsSyncSettings_UpdateMutation = { updateOrganisationIntegration: { __typename: 'UpdateOrganisationIntegrationResult', organisationIntegration: { __typename: 'OrganisationIntegration', id: string, settings: any } } };

export type PdsSyncSettings_RemoveMutationVariables = Types.Exact<{
  input: Types.RemoveOrganisationIntegrationInput;
}>;


export type PdsSyncSettings_RemoveMutation = { removeOrganisationIntegration: { __typename: 'RemoveOrganisationIntegrationResult', ok?: boolean | null } };

export type PdsSyncSettings_RotateTokenMutationVariables = Types.Exact<{
  newToken: Types.Scalars['String']['input'];
}>;


export type PdsSyncSettings_RotateTokenMutation = { updatePdsSyncToken: { __typename: 'PdsSyncTokenResult', ok: boolean } };


export const PdsSyncSettings_AddDocument = gql`
    mutation PdsSyncSettings_Add($input: AddOrganisationIntegrationInput!) {
  addOrganisationIntegration(input: $input) {
    organisationIntegration {
      id
      integration {
        integrationId
      }
      settings
    }
  }
}
    `;
export type PdsSyncSettings_AddMutationFn = Apollo.MutationFunction<PdsSyncSettings_AddMutation, PdsSyncSettings_AddMutationVariables>;

/**
 * __usePdsSyncSettings_AddMutation__
 *
 * To run a mutation, you first call `usePdsSyncSettings_AddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePdsSyncSettings_AddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pdsSyncSettingsAddMutation, { data, loading, error }] = usePdsSyncSettings_AddMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePdsSyncSettings_AddMutation(baseOptions?: Apollo.MutationHookOptions<PdsSyncSettings_AddMutation, PdsSyncSettings_AddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PdsSyncSettings_AddMutation, PdsSyncSettings_AddMutationVariables>(PdsSyncSettings_AddDocument, options);
      }
export type PdsSyncSettings_AddMutationHookResult = ReturnType<typeof usePdsSyncSettings_AddMutation>;
export type PdsSyncSettings_AddMutationResult = Apollo.MutationResult<PdsSyncSettings_AddMutation>;
export type PdsSyncSettings_AddMutationOptions = Apollo.BaseMutationOptions<PdsSyncSettings_AddMutation, PdsSyncSettings_AddMutationVariables>;
export const PdsSyncSettings_UpdateDocument = gql`
    mutation PdsSyncSettings_Update($input: UpdateOrganisationIntegrationInput!) {
  updateOrganisationIntegration(input: $input) {
    organisationIntegration {
      id
      settings
    }
  }
}
    `;
export type PdsSyncSettings_UpdateMutationFn = Apollo.MutationFunction<PdsSyncSettings_UpdateMutation, PdsSyncSettings_UpdateMutationVariables>;

/**
 * __usePdsSyncSettings_UpdateMutation__
 *
 * To run a mutation, you first call `usePdsSyncSettings_UpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePdsSyncSettings_UpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pdsSyncSettingsUpdateMutation, { data, loading, error }] = usePdsSyncSettings_UpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePdsSyncSettings_UpdateMutation(baseOptions?: Apollo.MutationHookOptions<PdsSyncSettings_UpdateMutation, PdsSyncSettings_UpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PdsSyncSettings_UpdateMutation, PdsSyncSettings_UpdateMutationVariables>(PdsSyncSettings_UpdateDocument, options);
      }
export type PdsSyncSettings_UpdateMutationHookResult = ReturnType<typeof usePdsSyncSettings_UpdateMutation>;
export type PdsSyncSettings_UpdateMutationResult = Apollo.MutationResult<PdsSyncSettings_UpdateMutation>;
export type PdsSyncSettings_UpdateMutationOptions = Apollo.BaseMutationOptions<PdsSyncSettings_UpdateMutation, PdsSyncSettings_UpdateMutationVariables>;
export const PdsSyncSettings_RemoveDocument = gql`
    mutation PdsSyncSettings_Remove($input: RemoveOrganisationIntegrationInput!) {
  removeOrganisationIntegration(input: $input) {
    ok
  }
}
    `;
export type PdsSyncSettings_RemoveMutationFn = Apollo.MutationFunction<PdsSyncSettings_RemoveMutation, PdsSyncSettings_RemoveMutationVariables>;

/**
 * __usePdsSyncSettings_RemoveMutation__
 *
 * To run a mutation, you first call `usePdsSyncSettings_RemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePdsSyncSettings_RemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pdsSyncSettingsRemoveMutation, { data, loading, error }] = usePdsSyncSettings_RemoveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePdsSyncSettings_RemoveMutation(baseOptions?: Apollo.MutationHookOptions<PdsSyncSettings_RemoveMutation, PdsSyncSettings_RemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PdsSyncSettings_RemoveMutation, PdsSyncSettings_RemoveMutationVariables>(PdsSyncSettings_RemoveDocument, options);
      }
export type PdsSyncSettings_RemoveMutationHookResult = ReturnType<typeof usePdsSyncSettings_RemoveMutation>;
export type PdsSyncSettings_RemoveMutationResult = Apollo.MutationResult<PdsSyncSettings_RemoveMutation>;
export type PdsSyncSettings_RemoveMutationOptions = Apollo.BaseMutationOptions<PdsSyncSettings_RemoveMutation, PdsSyncSettings_RemoveMutationVariables>;
export const PdsSyncSettings_RotateTokenDocument = gql`
    mutation PdsSyncSettings_RotateToken($newToken: String!) {
  updatePdsSyncToken(newToken: $newToken) {
    ok
  }
}
    `;
export type PdsSyncSettings_RotateTokenMutationFn = Apollo.MutationFunction<PdsSyncSettings_RotateTokenMutation, PdsSyncSettings_RotateTokenMutationVariables>;

/**
 * __usePdsSyncSettings_RotateTokenMutation__
 *
 * To run a mutation, you first call `usePdsSyncSettings_RotateTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePdsSyncSettings_RotateTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pdsSyncSettingsRotateTokenMutation, { data, loading, error }] = usePdsSyncSettings_RotateTokenMutation({
 *   variables: {
 *      newToken: // value for 'newToken'
 *   },
 * });
 */
export function usePdsSyncSettings_RotateTokenMutation(baseOptions?: Apollo.MutationHookOptions<PdsSyncSettings_RotateTokenMutation, PdsSyncSettings_RotateTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PdsSyncSettings_RotateTokenMutation, PdsSyncSettings_RotateTokenMutationVariables>(PdsSyncSettings_RotateTokenDocument, options);
      }
export type PdsSyncSettings_RotateTokenMutationHookResult = ReturnType<typeof usePdsSyncSettings_RotateTokenMutation>;
export type PdsSyncSettings_RotateTokenMutationResult = Apollo.MutationResult<PdsSyncSettings_RotateTokenMutation>;
export type PdsSyncSettings_RotateTokenMutationOptions = Apollo.BaseMutationOptions<PdsSyncSettings_RotateTokenMutation, PdsSyncSettings_RotateTokenMutationVariables>;